import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CellEditingStoppedEvent, ColDef, ValueGetterParams, ValueFormatterParams, GridApi, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { ObjectUnsubscribedError, Observable, catchError, filter, map, of } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Product } from "../../models/inventory-positions.model"

@Component({
  selector: 'app-warehouse-position-packages',
  templateUrl: './warehouse-position-packages.component.html',
  styleUrls: ['./warehouse-position-packages.component.scss']
})
export class WarehousePositionPackagesComponent implements ICellRendererAngularComp {

  public gridReady = false;
  public themeClass: string = "ag-theme-ulaap";

  products: Product[] = []

  showContent: boolean = false;

  public rowGroupPanelShow: "always" | "onlyWhenGrouping" | "never" = "always";

  constructor(private http: HttpClient) {
  }

  agInit(params: any): void {
    console.log('params', params)
    this.products = params.data.products
    this.showContent = true
  }

  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
  };

  public autoGroupColumnDef: ColDef = {
    minWidth: 200,
  };

  // headers for the products grid
  productColumnDefs: ColDef[] = [
    { field: 'product_serial_number', headerName: 'Serial No.', enableRowGroup: true },
    { field: 'product_model_number', headerName: 'Model No.', width: 180 },
    { field: 'description', headerName: 'Description'},
    { field: 'customer_contact_organization', enableRowGroup: true, headerName: 'Contact Organization'},
    { field: 'pallet_serial_number', enableRowGroup: true, headerName: 'Pallet Serial No.' },
    { field: 'width', headerName: 'Width', width: 100 },
    { field: 'height', headerName: 'Height', width: 100 },
    { field: 'length', headerName: 'Length', width: 100 },
    { field: 'weight', headerName: 'Weight', width: 100 },
    { field: 'type', headerName: 'Type', width: 100 }
  ]

  refresh(params: any): boolean {
    return false;
  }

}
